import { renderDate } from "@intrasync/utils";
import { ScheduleGridBodyCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";

interface AccountingScheduleLeftBodyCellProps
  extends ScheduleGridBodyCellProps {
  scheduleDate: string;
  rowCount: number;
  rowData: {
    entities: { type: "Invoice" | "Bill"; amount: number }[];
  };
}

const AccountingScheduleLeftBodyCell = (
  props: AccountingScheduleLeftBodyCellProps
) => {
  const { rowCount, scheduleDate, rowData } = props;

  // Calculate totals for invoices and bills separately
  const invoiceTotal =
    rowData?.entities?.reduce((sum, entity) => {
      return entity.type === "Invoice" ? sum + (entity.amount || 0) : sum;
    }, 0) || 0;

  const billTotal =
    rowData?.entities?.reduce((sum, entity) => {
      return entity.type === "Bill" ? sum + (entity.amount || 0) : sum;
    }, 0) || 0;

  // Calculate total amount for the day
  const totalAmount = invoiceTotal + billTotal;

  // Determine if bills exceed invoices
  const billsExceedInvoices = billTotal > invoiceTotal;

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Get currency styling based on bill vs invoice comparison
  const getCurrencyStyles = () => {
    if (billsExceedInvoices) {
      return {
        color: "#d32f2f", // Red text
        backgroundColor: "#ffebee", // Light red background
        border: "1px solid #ffcdd2", // Light red border
      };
    } else {
      return {
        color: "#2e7d32", // Green text
        backgroundColor: "#e8f5e8", // Light green background
        border: "1px solid #c8e6c9", // Light green border
      };
    }
  };

  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        ...props.style,
        // height: "90px",
        // width: "150px",
        // ...props.styles,
        // padding: "5px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        borderRadius: "4px",
        minHeight: "60px",
      }}
    >
      <div
        style={{
          fontWeight: "600",
          fontSize: "13px",
          color: "#1976d2",
          // marginBottom: "4px",
        }}
      >
        {renderDate(scheduleDate)}
      </div>
      {rowCount >= 1 && (
        <>
          <div
            style={{
              fontSize: "11px",
              color: "#757575",
              // marginBottom: "2px",
              fontWeight: "500",
            }}
          >
            {rowCount} {rowCount === 1 ? "item" : "items"}
          </div>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "700",
              padding: "2px 6px",
              borderRadius: "4px",
              cursor: "help",
              ...getCurrencyStyles(),
            }}
            title={`Invoices: ${formatCurrency(
              invoiceTotal
            )} | Bills: ${formatCurrency(billTotal)}`}
          >
            {formatCurrency(totalAmount)}
          </div>
        </>
      )}
    </div>
  );
};

export default AccountingScheduleLeftBodyCell;
